import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=606d2cb9&scoped=true&"
import script from "./BaseSelect.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseSelect.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&id=606d2cb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606d2cb9",
  null
  
)

export default component.exports